<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> REPORTE</v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
   
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="obtenerUrl()"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      url: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerReportePorUnidadGestion", item => {
      //this.tipo_documento = this.obtenerTipo(item)
      this.form = item;
      this.url = this.obtenerUrl();
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    obtenerUrl() {
      try {
   
        let url;
       let user=this.$storage.get("user");
        let gestion
         if (this.form.gestion) {
          gestion=parseInt(this.form.gestion)
        } else {
          gestion=this.$route.params.gestion
        }

        let nombre_reporte = "";
        let formato_doc = "output=pdf";
        let nombre_carpeta;
           nombre_carpeta="vacaciones"
        
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
        if (this.form.valor == 1 || this.form.valor == 3) {
          if (this.form.id_estado==72) {
            nombre_reporte = "rpt_cronograma_vacacion_historico";
          } else {
            nombre_reporte = "rpt_cronograma_vacacion_unidad"; 
          }
        }
         if (this.form.valor == 2  || this.form.valor == 4) {
          if (this.form.id_estado==72) {
            nombre_reporte = "rpt_cronograma_vacacion_historico";
          } else {
            nombre_reporte = "rpt_cronograma_vacacion_jerarquico"; 
          }
        }

         if (this.form.valor == 5) {
          if (this.form.id_estado==72) {
            nombre_reporte = "rpt_cronograma_vacacion_historico";
          } else {
            nombre_reporte = "rpt_cronograma_vacacion_jerarquico"; 
          }
        }
        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
         let url_parametros
        //Parametros
  
        // URL con parametros
           if (this.form.valor ==1 || this.form.valor ==3) {
           
            if (this.form.id_estado==72) {
              url_parametros = `${url}&P_ID_UNIDAD=${this.form.id_unidad}&P_PERIODO=${gestion}&P_ID_PERSONA`;
          } else {
            url_parametros = `${url}&id_unidad=${parseInt(this.form.id_unidad)}&gestion=${gestion}&id_persona=${user.id_persona}`;
          }
        }
          if (this.form.valor ==2) {
            if (this.form.id_estado==72) {
              url_parametros = `${url}&P_ID_UNIDAD=${this.form.id_unidad}&P_PERIODO=${gestion}&P_ID_PERSONA`;
          } else {
            url_parametros = `${url}&id_unidad=${parseInt(this.form.id_unidad)}&gestion=${gestion}&id_persona=${user.id_persona}`;
          }
        }
        if (this.form.valor ==4) {
          if (this.form.id_estado==72) {
              url_parametros = `${url}&P_ID_UNIDAD=${this.form.id_unidad}&P_PERIODO=${gestion}&P_ID_PERSONA`;
          } else {
            url_parametros = `${url}&id_unidad=${parseInt(this.form.id_unidad)}&gestion=${gestion}&id_persona=${parseInt(this.form.id_persona)}`;
          }
        }
     
          if (this.form.valor ==5) {
            if (this.form.id_estado==72) {
              url_parametros = `${url}&P_ID_UNIDAD=${this.form.id_unidad}&P_PERIODO=${gestion}&P_ID_PERSONA`;
          } else {
            url_parametros = `${url}&id_unidad=${parseInt(this.form.id_unidad)}&gestion=${gestion}&id_persona=${user.id_persona}`;
          }

        }

        console.log(url_parametros)
        return url_parametros;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
       this.$bus.$emit("closeDialogVerReportePorUnidadesGestion");
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/VerReportePorUnidadGestion.vue